import { classNames, tv, type VariantProps } from "@opensea/ui-kit"

export const topStickyVariants = tv({
  base: "sticky z-[1]",
  variants: {
    variant: {
      default: "top-0",
      "after-top-nav":
        "top-[theme(spacing.sm-top-nav)] lg:top-[theme(spacing.lg-top-nav)]",
      "after-top-nav-with-page-padding": classNames(
        "top-[calc(theme(spacing.sm-top-nav)+theme(spacing.4))]",
        "lg:top-[calc(theme(spacing.lg-top-nav)+theme(spacing.4))]",
      ),
      "after-filter-toolbar": classNames(
        "top-[calc(theme(spacing.sm-top-nav)+var(--spacing-filter-toolbar))]",
        "lg:top-[calc(theme(spacing.lg-top-nav)+var(--spacing-filter-toolbar))]",
      ),
      "after-filter-search-pills": classNames(
        "top-[calc(theme(spacing.sm-top-nav)+var(--spacing-filter-toolbar)+var(--spacing-filter-search-pills))]",
        "lg:top-[calc(theme(spacing.lg-top-nav)+var(--spacing-filter-toolbar)+var(--spacing-filter-search-pills))]",
      ),
      "after-hero-header-compact":
        "lg:top-[calc(theme(spacing.lg-top-nav)+theme(spacing.hero-header-compact))]",
      "after-hero-header-tab-menu": classNames(
        "top-[theme(spacing.sm-top-nav)]",
        "lg:top-[calc(theme(spacing.lg-top-nav)+theme(spacing.hero-header-compact)+theme(spacing.14))]",
      ),
      "after-hero-header-toolbar": classNames(
        "top-[calc(theme(spacing.sm-top-nav)+var(--spacing-filter-toolbar))]",
        "lg:top-[calc(theme(spacing.lg-top-nav)+theme(spacing.hero-header-compact)+theme(spacing.14)+var(--spacing-filter-toolbar))]",
      ),
      "after-hero-header-search-pills": classNames(
        "top-[calc(theme(spacing.sm-top-nav)+var(--spacing-filter-toolbar)+var(--spacing-filter-search-pills))]",
        "lg:top-[calc(theme(spacing.lg-top-nav)+theme(spacing.hero-header-compact)+theme(spacing.14)+var(--spacing-filter-toolbar)+var(--spacing-filter-search-pills))]",
      ),
      "after-sales-graph": classNames(
        "top-[calc(theme(spacing.sm-top-nav)+theme(spacing.hero-header-compact)+theme(spacing.14))]",
        "lg:top-[calc(theme(spacing.lg-top-nav)+theme(spacing.hero-header-compact)+theme(spacing.14))]",
      ),
      "after-activity-header": "top-[33px]",
    },
    tableHeader: {
      true: "scrollbar-hidden h-10",
      false: "",
    },
  },
  defaultVariants: {
    variant: "default",
  },
})

export type TopStickyVariant = VariantProps<typeof topStickyVariants>["variant"]
